export default "__VITE_ASSET__CFp7twnL__"